import React from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#060C1A] text-white pt-20 pb-8" role="contentinfo" data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-38">
          {/* Col 1: Brand */}
          <div className="col-span-2 lg:col-span-1" data-id="element-39">
            <Link to="/" className="inline-block mb-6" aria-label="Ambient Fingerprinting - Home" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/nTbFc2o4dVkYJauHPEt16Q/cropped-Media__1_-removebg-preview.png" alt="Ambient Fingerprinting" className="h-12 w-auto object-contain" data-id="element-41" />
            </Link>
            <p className="text-gray-300 leading-relaxed text-sm" data-id="element-42">
              With over a decade of experience, our team ensures exceptional
              quality and attention to detail, consistently exceeding
              expectations and setting new standards of service excellence.
            </p>
          </div>

          {/* Col 2: Company */}
          <div data-id="element-43">
            <h4 className="text-lg font-bold mb-6" data-id="element-44">Company</h4>
            <ul className="space-y-4" role="list" data-id="element-45">
              <li data-id="element-46">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-47">
                  About Us
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-49">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/who-we-serve" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-51">
                  Who We Serve
                </Link>
              </li>
              <li data-id="element-52">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-53">
                  Terms and Conditions
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div data-id="element-54">
            <h4 className="text-lg font-bold mb-6" data-id="element-55">Services</h4>
            <ul className="space-y-4" role="list" data-id="element-56">
              <li data-id="element-57">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-58">
                  LiveScan Fingerprinting
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/booking" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-60">
                  Background Checks
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/booking" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-62">
                  Mobile Fingerprinting
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/booking" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-64">
                  Ink/Card Fingerprinting
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div data-id="element-65">
            <h4 className="text-lg font-bold mb-6" data-id="element-66">Contact Us</h4>
            <ul className="space-y-4" role="list" data-id="element-67">
              <li className="flex items-start gap-3 text-sm text-gray-300" data-id="element-68">
                <MapPinIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-69" />
                <span data-id="element-70">
                  10632 Little Patuxent Pkwy, Suite 302, Columbia, MD 21044
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-300" data-id="element-71">
                <PhoneIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0" aria-hidden="true" data-id="element-72" />
                <a href="tel:4105255285" className="hover:text-white transition-colors" data-id="element-73">
                  410-525-5285
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-300" data-id="element-74">
                <ClockIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-75" />
                <span data-id="element-76">
                  Mon-Fri 7am-7pm
                  <br data-id="element-77" />
                  Sat 9am-5pm (by appointment)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-78">
          <p className="text-gray-400 text-sm text-center md:text-left" data-id="element-79">
            &copy; 2026 Ambient Solutions, LLC. DBA Ambient Fingerprinting
            Solution.
          </p>
          <p className="text-gray-400 text-sm" data-id="element-80">Designed with care</p>
        </div>
      </div>
    </footer>;
}